export default (urlParameters) => {
  // jWeather Configuration Globals
  if (Object.prototype.hasOwnProperty.call(window.$App.globals, 'configuration')) {
    const configurationGlobals = Object.entries(window.$App.globals.configuration)
    configurationGlobals.forEach((global) => (jweather[global[0]] = global[1]))
  }

  // jWeather User Settings
  if (Object.prototype.hasOwnProperty.call(window.$App.globals, 'user')) {
    jweather.user = {}
    const userSettings = Object.entries(window.$App.globals.user)
    userSettings.forEach((setting) => (jweather.user[setting[0]] = setting[1]))
  }

  // jWeather General Settings
  if (Object.prototype.hasOwnProperty.call(window.$App.globals, 'settings')) {
    jweather.settings = new jweather.GeneralSettings(window.$App.globals.user.settings)
  }

  // jWeather Ads
  if (Object.prototype.hasOwnProperty.call(window.$App.globals, 'ads')) {
    jweather.Ads = {}
    const jweatherAdConfiguration = Object.entries(window.$App.globals.ads)
    jweatherAdConfiguration.forEach(
      (configuration) => (jweather.Ads[configuration[0]] = configuration[1])
    )
  }
}